module.exports = __webpack_public_path__ + "img/shopex.cd9de814.png";